<script>
import { fandomBasicMixin } from 'src/modules/fandom_mixins_module.js';

export default {
  mixins: [fandomBasicMixin],
  props: {
    index: {
      type: Number
    },
    entry: {
      type: Object
    }
  },
  methods: {
    getUsernameByUser: Fandom.getUsernameByUser,
    getUserAvatarByUser: Fandom.getUserAvatarByUser,
    applyContextToUrl: Fandom.applyContextToUrl,
    getCurrentUserId() {
      if (Fandom.isUserRegistered()) {
        return globalState.pageModel.user.id;
      }
    },
    getRowBackgroundClass(i){
      return i % 2 == 1 ? "bg-kenwood-light-grey" : "";
    }
  }
};
</script>

<template>
  <div class="row align-items-center flex-nowrap py-2 vote-ranking-entry mx-2 mx-sm-0" :class="[{'active': getCurrentUserId() == entry.user.id}, getRowBackgroundClass(index)]" vote-ranking-entry-component>
    <div class="col-12 d-flex align-items-center">
      <div class="ranking-entry-username mb-0 flex-grow-1">
        {{entry.position}}. {{getUsernameByUser(entry.user)}}
      </div>
      <div class="ugc-info-container d-flex align-items-center justify-content-between">
        <a class="d-flex align-items-center text-black" :href="applyContextToUrl(entry.slug)">
          <span class="pr-2 pt-1 text-uppercase">{{ft("globals.watch")}}</span>
          <svg id="play-icon"><use xlink:href="#play-icon-only"></use></svg>
        </a>
        <div class="px-3 px-md-4 py-1 d-inline-flex vote-ranking-entry-reward-marker align-items-center text-black justify-content-end">
          <span class="pr-1 pt-1 text-uppercase">{{entry.counter}}</span>
          <svg id="star-icon"><use xlink:href="#star-o"></use></svg>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
[vote-ranking-entry-component] {

  svg#star-icon{
    stroke: $black;
    width: 1.1rem;
    height: 1.1rem;
  }

  svg#play-icon{
    stroke: $black;
    width: 0.9rem;
    height: 0.9rem;
  }

  .ugc-info-container {
    width: 35%;
  }

  .vote-ranking-entry-reward-marker {
    border-radius: 2rem;
    min-width: 5rem;
    background-color: $cheddar;
  }

  @include media-breakpoint-down(xs) {
    .vote-ranking-entry-reward-marker {
      min-width: 4rem;
    }

    .ugc-info-container {
      width: 43%;
    }
  }

}
</style>